import React from 'react';

import api            from '../../../../../../../api';
import values         from '../../../../../../../values';
import Context        from '../../../../../../../context';
import FindDebtScreen from '..';

import { TModal                        } from '../../../../../../../types/common.type';
import { useQuery                      } from 'react-query';
import { IFindApproveParentTransaction } from '../../../../../../../types/common.interface';

const ApproveParentTransactionContainer = () => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedPayment, setSelectedPayment] = React.useState<any>();

  const [requestApproveParentTransaction, setRequestApproveParentTransaction] =
    React.useState<IFindApproveParentTransaction>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const approvedParentTransaction = useQuery(
    [values.useQueryKeys.approvedParentTransaction, requestApproveParentTransaction, selectedYear?._id],
    () => api.post.administrator.findApprovedParentTransaction({ ...requestApproveParentTransaction, academicYear: selectedYear?._id })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.ApproveParentTransactionScreen.Provider
      value={{
        isLoading                      ,
        showModal                      ,
        selectedPayment                ,
        approvedParentTransaction      ,
        requestApproveParentTransaction,
        setIsLoading                      ,
        setShowModal                      ,
        setSelectedPayment                ,
        setRequestApproveParentTransaction,
      }}
    >
      <FindDebtScreen rqData={approvedParentTransaction} showModalData={{}} />
    </Context.ApproveParentTransactionScreen.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default ApproveParentTransactionContainer;
